document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-animate]').forEach(el=>{el.style.opacity='0';el.style.transform='translateY(22px)'});
  const io=new IntersectionObserver(entries=>{entries.forEach(e=>{if(e.isIntersecting){e.target.style.transition='opacity .7s ease, transform .7s ease';e.target.style.opacity='1';e.target.style.transform='translateY(0)';io.unobserve(e.target)}})},{threshold:.12});
  document.querySelectorAll('[data-animate]').forEach(el=>io.observe(el));

  document.querySelectorAll('[data-wise-cart-form]').forEach(form=>{
    form.querySelectorAll('[data-wise-qty-minus],[data-wise-qty-plus]').forEach(btn=>{
      btn.addEventListener('click',()=>{
        const wrap=btn.closest('.wise-qty');
        const input=wrap && wrap.querySelector('.wise-qty-input');
        if(!input) return;
        const current=parseInt(input.value || '0',10);
        const next=btn.hasAttribute('data-wise-qty-plus') ? current + 1 : Math.max(0,current - 1);
        input.value=next;
        input.dispatchEvent(new Event('change',{bubbles:true}));
      });
    });
  });
});
